import { z } from 'zod';

export const documentTypeSchema = z
  .object({
    id: z.number().int(),
    name: z.string(),
    official_name: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
  })
  .transform((raw) => ({
    key: String(raw.id),
    value: raw.official_name || raw.name,
  }));

export type DocumentTypeOption = z.output<typeof documentTypeSchema>;
export type DocumentTypeApi = z.input<typeof documentTypeSchema>;
